module.exports = __webpack_public_path__ + "static/img/email_bear@2x.8e2be45.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/onboarding/views/invite/images/email_bear@2x.png
// module id = G2Yb
// module chunks = 12